import alamo from "./imgs/alamo.jpg";
import costaMesa from "./imgs/costa-mesa.jpg";
export interface IModelHomeInfo {
  location_title: string;
  product_title: string;
  schedule_link: string;
  badge: string;
  image: string;
}

// 09/11/2023 Removed per request - NET-795
// const NORTH_BAY_MODEL_HOME: IModelHomeInfo = {
//   location_title: "Santa Rosa, North Bay",
//   product_title: "The H1200b",
//   schedule_link: "https://calendly.com/villa-model-homes/santa-rosa",
//   image_url:
//     "https://villahomes.com/wp-content/uploads/2022/09/Santa-Rosa-Exterior-scaled.jpg",
// };

const EAST_BAY_MODEL_HOME: IModelHomeInfo = {
  location_title: "Alamo, CA",
  product_title: "3 bed • 2 bath • 1,200 sq. ft.",
  badge: "Northern California",
  image: alamo,
  schedule_link:
    "https://calendly.com/villa-model-homes/alamo-model-home-tour-villa?from=villa-app",
};
const SOUTHERN_CALIFORNIA_MODEL_HOME: IModelHomeInfo = {
  location_title: "Costa Mesa, CA",
  product_title: "2 bed • 2 bath • 1,000 sq. ft.",
  badge: "Southern California",
  image: costaMesa,
  schedule_link:
    "https://calendly.com/villa-model-homes/villa-costa-mesa-model-home-tour?from=villa-app",
};

// 08/29/2024 Removed per request - LG-1497
// const SAN_DIEGO_MODEL_HOME: IModelHomeInfo = {
//   location_title: "San Diego",
//   product_title: "The H1000b",
//   schedule_link: "https://calendly.com/villa-model-homes/san-diego",
//   image_url:
//     "https://villahomes.com/wp-content/uploads/2023/09/Model-Home-Tours-San-Diego.jpg",
// };

// 10/24/2024 Removed per request - LG-1578
// const SOUTH_BAY_MODEL_HOME: IModelHomeInfo = {
//   location_title: "Saratoga, South Bay",
//   product_title: "The H800",
//   schedule_link:
//     "https://calendly.com/villa-model-homes/saratoga-model-home-tour",
//   image_url:
//     "https://villahomes.com/wp-content/uploads/2023/07/Model-Home-Tours-Saratoga-South-Bay.jpg",
// };

export const MODEL_HOMES: IModelHomeInfo[] = [
  EAST_BAY_MODEL_HOME,
  SOUTHERN_CALIFORNIA_MODEL_HOME,
  // SOUTH_BAY_MODEL_HOME,
];
